/**
 * Reads `prefers-reduced-motion` once, guarded the same way route-tabs.jsx
 * guards its own read: some environments (older jsdom without a full
 * `matchMedia` stub) throw rather than returning a MediaQueryList.
 *
 * @returns {boolean}
 */
export default function prefersReducedMotion() {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  } catch {
    return false
  }
}
